<template>
  <div class="navbar-container d-flex content align-items-center">
    <BannerNotif />

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="GridIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <b-navbar-nav class="nav align-items-center mr-auto d-none d-lg-flex">
      <span class="brand-logo">
        <b-img
          :src="appLogoImage"
          alt="logo"
        />
      </span>
      <h2 class="brand-text">
        {{ appName }}
      </h2>

      <div>
        <div class="min-w-[39px] bg-[#BEFCDE] rounded flex items-center justify-center text-[10px] ml-[-20px] mt-[2px]">
          {{ app_version }}
        </div>
      </div>

      <div class="ml-2 mt-[2px]">
        <button
          v-if="isDevEnv"
          class="d-flex align-items-center border-0 text-white font-weight-bold btn-highlight-anim"
          style="
            padding: 3px 10px; 
            background: linear-gradient(135deg, #FF7A59 0%, #F95031 100%); 
            border-radius: 20px; 
            font-size: 11px; 
            transition: all 0.3s ease; 
            height: 24px;
          "
          onmouseover="this.style.transform='translateY(-1px)'"
          onmouseout="this.style.transform='translateY(0)'"
          @click="switchToNewVersion"
        >
          <span
            class="mr-1"
            style="animation: pulse 2s infinite; font-size: 13px;"
          >✨</span>
          Coba Versi Baru
        </button>
      </div>
    </b-navbar-nav>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none">
      <!-- Bookmarks Container -->
      <bookmarks />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <user-dropdown />
      <notification-dropdown v-if="false" />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BImg,
} from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import Bookmarks from './components/Bookmarks.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'
import BannerNotif from './components/BannerNotification.vue'

export default {
  components: {
    BLink,
    BImg,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    NotificationDropdown,
    UserDropdown,
    BannerNotif,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      // App Name
      appName,
      appLogoImage,
    }
  },
  data() {
    return {
      isDevEnv: false,
    }
  },
  computed: {
    app_version() {
      return process.env.VUE_APP_VERSION
    },
  },
  mounted() {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname
      this.isDevEnv = host === 'localhost' || host === '127.0.0.1' || host.startsWith('dev.')
    }
  },
  methods: {
    switchToNewVersion(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }

      // Selalu simpan state versi ke localStorage
      localStorage.setItem('komerce_version', 'v2')

      if (window.parent && window.parent !== window) {
        // Jika berada di dalam Iframe (dari host React), kirim pesan postMessage
        window.parent.postMessage({ type: 'SWITCH_LAYOUT_VERSION', version: 'v2' }, '*')
      } else if (window.location.port) {
        // Jika berjalan mandiri (Standalone)
        // Mengecek apakah kita sedang di development port (8081 atau sejenisnya)
        // Paksa pindah ke port 8080 (React host) dengan host yang sama
        window.location.href = `http://${window.location.hostname}:8080${window.location.pathname}${window.location.search}`
      } else {
        // Di production/staging, gunakan reload
        window.location.reload()
      }
    },
  },
}
</script>

<style scoped>
.btn-highlight-anim {
  animation: attention-pulse 2.5s infinite;
}

@keyframes attention-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(249, 80, 49, 0.6);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(249, 80, 49, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(249, 80, 49, 0);
  }
}
</style>
